import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Navbar from '../../components/Navbar';
import SidebarSeccion from '../../components/SidebarSeccion';
import { useAuth, API_URL } from '../../context/AuthContext';
import { getTema } from '../../theme';

const TIPO_CONFIG = {
  examen:       { color: '#EC4899', bg: '#FCE7F3', icon: '🧪', label: 'Examen' },
  actividad:    { color: '#8B5CF6', bg: '#EDE9FE', icon: '📋', label: 'Actividad' },
  clase_online: { color: '#10B981', bg: '#D1FAE5', icon: '🎥', label: 'Clase online' },
  clase_grabada:{ color: '#F59E0B', bg: '#FEF3C7', icon: '🎬', label: 'Clase grabada' },
  speaking:     { color: '#3B82F6', bg: '#DBEAFE', icon: '🎙️', label: 'Speaking' },
};

const DIAS_SEMANA = ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'];
const MESES = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];

function getDiasDelMes(anio, mes) {
  const primerDia = new Date(anio, mes, 1);
  const ultimoDia = new Date(anio, mes + 1, 0);
  // getDay() returns 0=Sun, adjust so Mon=0
  let inicioSemana = primerDia.getDay() - 1;
  if (inicioSemana < 0) inicioSemana = 6;
  const dias = [];
  for (let i = 0; i < inicioSemana; i++) dias.push(null);
  for (let d = 1; d <= ultimoDia.getDate(); d++) dias.push(d);
  while (dias.length % 7 !== 0) dias.push(null);
  return dias;
}

function fechaStr(fecha) {
  if (!fecha) return null;
  if (typeof fecha === 'string') return fecha.split('T')[0];
  return fecha;
}

export default function Calendario({ tipo, nivel }) {
  const { usuario } = useAuth();
  const navigate = useNavigate();
  const tema = getTema(tipo);

  const hoy = new Date();
  const [anio, setAnio] = useState(hoy.getFullYear());
  const [mes, setMes] = useState(hoy.getMonth());
  const [eventos, setEventos] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [diaSeleccionado, setDiaSeleccionado] = useState(null);

  useEffect(() => {
    const cargar = async () => {
      try {
        setCargando(true);
        const res = await axios.get(`${API_URL}/calendario?tipo=${tipo}&nivel=${nivel}`);
        setEventos(res.data);
      } catch { setEventos([]); }
      finally { setCargando(false); }
    };
    cargar();
  }, [tipo, nivel]);

  const prevMes = () => {
    if (mes === 0) { setMes(11); setAnio(a => a - 1); }
    else setMes(m => m - 1);
    setDiaSeleccionado(null);
  };

  const nextMes = () => {
    if (mes === 11) { setMes(0); setAnio(a => a + 1); }
    else setMes(m => m + 1);
    setDiaSeleccionado(null);
  };

  const irHoy = () => { setAnio(hoy.getFullYear()); setMes(hoy.getMonth()); setDiaSeleccionado(hoy.getDate()); };

  const getEventosDia = (dia) => {
    if (!dia) return [];
    const fechaTarget = `${anio}-${String(mes + 1).padStart(2, '0')}-${String(dia).padStart(2, '0')}`;
    return eventos.filter(e => fechaStr(e.fecha) === fechaTarget);
  };

  const getEventosMes = () => {
    const prefijo = `${anio}-${String(mes + 1).padStart(2, '0')}`;
    return eventos.filter(e => fechaStr(e.fecha)?.startsWith(prefijo));
  };

  const dias = getDiasDelMes(anio, mes);
  const hoyStr = `${hoy.getFullYear()}-${String(hoy.getMonth() + 1).padStart(2,'0')}-${String(hoy.getDate()).padStart(2,'0')}`;
  const eventosMesActual = getEventosMes();

  const irAEvento = (ev) => {
    if (ev.tipo_evento === 'examen' || ev.tipo_evento === 'actividad') {
      navigate(`/${tipo}/${nivel}/actividades`);
    } else if (ev.tipo_evento === 'clase_online') {
      navigate(`/${tipo}/${nivel}/clases-online`);
    } else if (ev.tipo_evento === 'clase_grabada') {
      navigate(`/${tipo}/${nivel}/clases-grabadas`);
    } else if (ev.tipo_evento === 'speaking') {
      navigate(`/${tipo}/${nivel}/actividades`);
    }
  };

  const eventosDiaSeleccionado = diaSeleccionado ? getEventosDia(diaSeleccionado) : [];

  return (
    <div style={{ minHeight: '100vh', background: tema.bg }}>
      <Navbar tema={tema} titulo={tipo === 'militar' ? 'Programa Militar' : 'Inglés Civil'} tipo={tipo} nivel={nivel} />
      <div className="page-layout">
        <SidebarSeccion tema={tema} tipo={tipo} nivel={nivel} />
        <main className="page-content">
          <div className="fade-in">
            {/* Header */}
            <div className="section-header" style={{ marginBottom: '24px' }}>
              <div>
                <h2 style={{ color: tema.text, fontSize: '26px', marginBottom: '4px' }}>📅 Calendario</h2>
                <p style={{ color: tema.muted, fontSize: '14px' }}>Actividades, exámenes y clases programadas para {nivel}</p>
              </div>
              <button onClick={irHoy}
                style={{ background: tema.primary, border: 'none', color: '#fff', padding: '9px 20px', borderRadius: '50px', fontSize: '13px', fontWeight: 600, cursor: 'pointer', boxShadow: '0 4px 14px rgba(236,72,153,0.35)' }}>
                Hoy
              </button>
            </div>

            <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap', alignItems: 'flex-start' }}>
              {/* Calendario */}
              <div style={{ flex: '1 1 460px', background: tema.bgCard, border: `1px solid ${tema.border}`, borderRadius: '16px', overflow: 'hidden' }}>
                {/* Navegación mes */}
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '18px 22px', borderBottom: `1px solid ${tema.border}` }}>
                  <button onClick={prevMes}
                    style={{ background: `${tema.accent}15`, border: `1px solid ${tema.accent}33`, color: tema.accent, width: 36, height: 36, borderRadius: '50%', fontSize: '18px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    ‹
                  </button>
                  <h3 style={{ color: tema.text, fontSize: '18px', fontFamily: 'Inter, sans-serif', fontWeight: 700, margin: 0 }}>
                    {MESES[mes]} {anio}
                  </h3>
                  <button onClick={nextMes}
                    style={{ background: `${tema.accent}15`, border: `1px solid ${tema.accent}33`, color: tema.accent, width: 36, height: 36, borderRadius: '50%', fontSize: '18px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    ›
                  </button>
                </div>

                {/* Días de la semana */}
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', padding: '10px 12px 4px' }}>
                  {DIAS_SEMANA.map(d => (
                    <div key={d} style={{ textAlign: 'center', color: tema.muted, fontSize: '12px', fontWeight: 600, padding: '4px 0', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                      {d}
                    </div>
                  ))}
                </div>

                {/* Grid de días */}
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', padding: '4px 12px 16px', gap: '2px' }}>
                  {dias.map((dia, idx) => {
                    if (!dia) return <div key={idx} />;
                    const diaStr = `${anio}-${String(mes + 1).padStart(2,'0')}-${String(dia).padStart(2,'0')}`;
                    const esHoy = diaStr === hoyStr;
                    const seleccionado = diaSeleccionado === dia;
                    const eventosDia = getEventosDia(dia);
                    const tiposUnicos = [...new Set(eventosDia.map(e => e.tipo_evento))];

                    return (
                      <div key={idx} onClick={() => setDiaSeleccionado(seleccionado ? null : dia)}
                        style={{
                          minHeight: '48px', borderRadius: '8px', padding: '4px 4px 6px',
                          cursor: 'pointer', position: 'relative',
                          background: seleccionado ? `${tema.accent}18` : esHoy ? `${tema.accent}08` : 'transparent',
                          border: seleccionado ? `1.5px solid ${tema.accent}` : esHoy ? `1.5px solid ${tema.accent}44` : '1.5px solid transparent',
                          transition: 'all 0.12s',
                        }}>
                        <div style={{
                          textAlign: 'center',
                          fontSize: '13px',
                          fontWeight: esHoy || seleccionado ? 700 : 400,
                          color: esHoy ? tema.accent : seleccionado ? tema.accent : tema.text,
                          marginBottom: '4px',
                          lineHeight: 1,
                          padding: '2px 0',
                        }}>
                          {esHoy ? (
                            <span style={{ background: tema.accent, color: '#fff', borderRadius: '50%', width: 22, height: 22, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px' }}>
                              {dia}
                            </span>
                          ) : dia}
                        </div>
                        {tiposUnicos.length > 0 && (
                          <div style={{ display: 'flex', justifyContent: 'center', gap: '2px', flexWrap: 'wrap' }}>
                            {tiposUnicos.slice(0, 3).map(t => (
                              <span key={t} style={{
                                width: 7, height: 7, borderRadius: '50%',
                                background: TIPO_CONFIG[t]?.color || tema.accent,
                                display: 'inline-block',
                              }} />
                            ))}
                            {tiposUnicos.length > 3 && (
                              <span style={{ fontSize: '9px', color: tema.muted }}>+</span>
                            )}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>

                {/* Leyenda */}
                <div style={{ borderTop: `1px solid ${tema.border}`, padding: '12px 16px', display: 'flex', gap: '14px', flexWrap: 'wrap' }}>
                  {Object.entries(TIPO_CONFIG).map(([key, cfg]) => (
                    <div key={key} style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                      <span style={{ width: 8, height: 8, borderRadius: '50%', background: cfg.color, display: 'inline-block' }} />
                      <span style={{ color: tema.muted, fontSize: '11px' }}>{cfg.label}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Panel derecho */}
              <div style={{ flex: '1 1 260px', display: 'flex', flexDirection: 'column', gap: '16px' }}>

                {/* Eventos del día seleccionado */}
                {diaSeleccionado && (
                  <div style={{ background: tema.bgCard, border: `1px solid ${tema.accent}44`, borderRadius: '14px', padding: '18px' }}>
                    <h4 style={{ color: tema.accent, fontSize: '15px', marginBottom: '14px', fontFamily: 'Inter, sans-serif' }}>
                      📅 {diaSeleccionado} de {MESES[mes]}
                    </h4>
                    {eventosDiaSeleccionado.length === 0 ? (
                      <p style={{ color: tema.muted, fontSize: '14px', textAlign: 'center', padding: '16px 0' }}>Sin eventos este día</p>
                    ) : (
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        {eventosDiaSeleccionado.map(ev => {
                          const cfg = TIPO_CONFIG[ev.tipo_evento] || TIPO_CONFIG.examen;
                          return (
                            <div key={ev.id} onClick={() => irAEvento(ev)}
                              style={{ background: cfg.bg, border: `1px solid ${cfg.color}33`, borderRadius: '10px', padding: '10px 14px', cursor: 'pointer', transition: 'transform 0.1s' }}
                              onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.01)'}
                              onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <span style={{ fontSize: '16px' }}>{cfg.icon}</span>
                                <div>
                                  <p style={{ color: '#1a1a2e', fontWeight: 600, fontSize: '13px', margin: 0 }}>{ev.titulo}</p>
                                  <p style={{ color: cfg.color, fontSize: '11px', fontWeight: 600, margin: '2px 0 0' }}>{cfg.label}{ev.hora ? ` · ${ev.hora}` : ''}{ev.categoria ? ` · ${ev.categoria}` : ''}</p>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                )}

                {/* Próximos eventos del mes */}
                <div style={{ background: tema.bgCard, border: `1px solid ${tema.border}`, borderRadius: '14px', padding: '18px' }}>
                  <h4 style={{ color: tema.text, fontSize: '15px', marginBottom: '14px', fontFamily: 'Inter, sans-serif' }}>
                    Este mes
                    {eventosMesActual.length > 0 && (
                      <span style={{ marginLeft: '8px', background: `${tema.accent}18`, color: tema.accent, fontSize: '11px', fontWeight: 700, padding: '2px 8px', borderRadius: '10px' }}>
                        {eventosMesActual.length}
                      </span>
                    )}
                  </h4>
                  {cargando ? (
                    <p style={{ color: tema.muted, fontSize: '14px' }}>Cargando...</p>
                  ) : eventosMesActual.length === 0 ? (
                    <div style={{ textAlign: 'center', padding: '20px 0' }}>
                      <div style={{ fontSize: '32px', marginBottom: '8px' }}>📭</div>
                      <p style={{ color: tema.muted, fontSize: '13px' }}>No hay eventos este mes</p>
                    </div>
                  ) : (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                      {eventosMesActual
                        .sort((a, b) => (fechaStr(a.fecha) || '').localeCompare(fechaStr(b.fecha) || ''))
                        .map(ev => {
                          const cfg = TIPO_CONFIG[ev.tipo_evento] || TIPO_CONFIG.examen;
                          const fecha = new Date(fechaStr(ev.fecha) + 'T12:00:00');
                          return (
                            <div key={ev.id} onClick={() => { setDiaSeleccionado(fecha.getDate()); irAEvento(ev); }}
                              style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '8px 10px', borderRadius: '8px', cursor: 'pointer', background: `${cfg.color}0A`, border: `1px solid ${cfg.color}22`, transition: 'background 0.1s' }}
                              onMouseEnter={e => e.currentTarget.style.background = cfg.bg}
                              onMouseLeave={e => e.currentTarget.style.background = `${cfg.color}0A`}>
                              <div style={{ background: cfg.color, color: '#fff', borderRadius: '8px', padding: '4px 8px', minWidth: '32px', textAlign: 'center' }}>
                                <div style={{ fontSize: '13px', fontWeight: 700, lineHeight: 1 }}>{fecha.getDate()}</div>
                                <div style={{ fontSize: '9px', lineHeight: 1, marginTop: '1px', textTransform: 'uppercase' }}>{MESES[fecha.getMonth()].slice(0,3)}</div>
                              </div>
                              <div style={{ flex: 1, minWidth: 0 }}>
                                <p style={{ color: tema.text, fontWeight: 600, fontSize: '13px', margin: 0, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{ev.titulo}</p>
                                <p style={{ color: tema.muted, fontSize: '11px', margin: '1px 0 0' }}>{cfg.icon} {cfg.label}</p>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  )}
                </div>

                {/* Todos los próximos eventos (futuros) */}
                {(() => {
                  const futuros = eventos
                    .filter(e => fechaStr(e.fecha) >= hoyStr)
                    .sort((a, b) => (fechaStr(a.fecha) || '').localeCompare(fechaStr(b.fecha) || ''))
                    .slice(0, 5);
                  if (futuros.length === 0) return null;
                  return (
                    <div style={{ background: tema.bgCard, border: `1px solid ${tema.border}`, borderRadius: '14px', padding: '18px' }}>
                      <h4 style={{ color: tema.text, fontSize: '15px', marginBottom: '14px', fontFamily: 'Inter, sans-serif' }}>
                        Próximos eventos
                      </h4>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        {futuros.map(ev => {
                          const cfg = TIPO_CONFIG[ev.tipo_evento] || TIPO_CONFIG.examen;
                          const fecha = new Date(fechaStr(ev.fecha) + 'T12:00:00');
                          const diffDias = Math.ceil((fecha - new Date(hoyStr)) / (1000 * 60 * 60 * 24));
                          return (
                            <div key={ev.id} onClick={() => irAEvento(ev)}
                              style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '8px 10px', borderRadius: '8px', cursor: 'pointer', background: cfg.bg, border: `1px solid ${cfg.color}33` }}>
                              <span style={{ fontSize: '18px' }}>{cfg.icon}</span>
                              <div style={{ flex: 1, minWidth: 0 }}>
                                <p style={{ color: '#1a1a2e', fontWeight: 600, fontSize: '13px', margin: 0, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{ev.titulo}</p>
                                <p style={{ color: cfg.color, fontSize: '11px', fontWeight: 600, margin: '2px 0 0' }}>
                                  {diffDias === 0 ? '¡Hoy!' : diffDias === 1 ? 'Mañana' : `En ${diffDias} días`}
                                  {' · '}{fecha.toLocaleDateString('es-ES', { day: 'numeric', month: 'short' })}
                                </p>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })()}
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
